export default __webpack_public_path__ + "static/media/possibility_2.adebd8e3.png";